import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './page-not-found.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadChildren: './implementation/implementation.module#ImplementationModule'
  },
  {
    path: '**',
    component: PageNotFoundComponent
  },
  { path: '', redirectTo: '/mall/mallhome', pathMatch: 'full' },
];


@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
      , {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'top', // 这里管跳转路由后页面始终在顶部
        }
      // , { enableTracing: true } // debugging purposes only
    ),
  ],
  declarations: [
    PageNotFoundComponent
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
